
const Definition = {

    id: "sleeky",
    plan_level: 2,
    name: "Sleeky",
    path: "member/sleeky/components/Landing",
    preview_image: "https://img.freepik.com/free-vector/contour-line-background_53876-93503.jpg",
    colors: {
        main_color1: "#0A0A0F",
        primary_color: "#C9A84C",
        primary_color_light: "#E8C96A"
    }

};

export default Definition;
